import { ChangeNames, ChangeTypes } from "../clients/FirebaseClient/types";

export const sumUpChargingStationPower = (
    stations: ChangeTypes[ChangeNames.CHARGER_CHARGING_STATIONS]["value"],
): number =>
    stations.reduce(
        (acc, chargingStation) =>
            chargingStation.count *
                chargingStation.chargingPoints.reduce(
                    (acc2, chargingPoint) => (chargingPoint.value.amount ?? 0) + acc2,
                    0,
                ) +
            acc,
        0,
    );
